import { checkAuth as apiCheckAuth, login as apiLogin, logout as apiLogout } from './api/auth';

/**
 * Get token from local storage
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem('token');
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = (): boolean => {
  const token = getAuthToken();
  return !!token;
};

/**
 * Save token to local storage
 */
export const setAuthToken = (token: string): void => {
  localStorage.setItem('token', token);
};

/**
 * Logout process
 * Send logout request to API and remove token from local storage
 */
export const logout = async (): Promise<void> => {
  try {
    // Send logout request to API
    await apiLogout();
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
    // Remove token from local storage
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  }
};

/**
 * User authentication
 * Send API request and save returned token
 */
export const login = async (username: string, password: string): Promise<boolean> => {
  try {
    const response = await apiLogin({ username, password });

    // Save token
    setAuthToken(response.token);

    // Save user information
    localStorage.setItem('user', JSON.stringify(response.user));

    return true;
  } catch (error) {
    console.error('Login error:', error);
    return false;
  }
};

/**
 * Create authentication headers
 */
export const getAuthHeaders = (): Record<string, string> => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Check authentication status
 */
export const checkAuthentication = async (): Promise<boolean> => {
  try {
    return await apiCheckAuth();
  } catch (error) {
    console.error('Authentication check failed:', error);
    return false;
  }
};
